const data = {
	hostname: 'zautomotiverepairs.com.au',
	id: 'tzautomotiverepairs',
	bookingLink: 'https://book.repairy.au/tzautomotiverepairs',
	name: 'TZ Automotive Repairs',
	logo: '/images/TZAutomotiveRepairs/logo.png',
	heroImage: '/images/TZAutomotiveRepairs/hero.jpg',
	theme: '#ff0000',
	intro:
		'Where technical mastery meets world-class service. We leverage our extensive industry heritage to provide repairs that last and a customer experience that puts you first, every single time.',
	googleAds: {
		metaTitle: 'Book service — TZ Automotive Repairs',
		metaDescription:
			'Book tyres (Michelin and BF Goodrich), basic services, batteries and wheel alignment online at TZ Automotive Repairs.',
		eyebrow: 'TZ Automotive Repairs',
		headline: 'Book for tyres, batteries, alignment or general servicing online',
		subheadline:
			'Tyre fitting including Michelin and BF Goodrich, minor repairs and regular maintenance, battery inspection and replacement with vehicle safety inspections, and wheel alignment for modern suspensions.',
		bullets: [
			'Tyre specialist — Michelin and BF Goodrich with fitting equipment',
			'Basic services — minor repairs and regular maintenance',
			'Batteries and wheel alignment — safety inspections and modern alignment',
			'Book online — your slot is reserved instantly',
		],
		primaryCta: 'Book now',
	},
	services: [
		{
			id: 1,
			type: 'Tyre Specialist',
			content:
				'We offer a great range of tyres, including Michelin and BF Goodrich and have the experience and equipment to make sure you get the right job done the first time.',
		},
		{
			id: 2,
			type: 'Basic services',
			content:
				'Our team is fully qualified to assist you with any minor repairs or regular maintenance.',
		},
		{
			id: 3,
			type: 'Battery replacement',
			content:
				'We offer full battery inspection and replacement as well as vehicle safety inspections.',
		},
		{
			id: 4,
			type: 'Wheel Alignment',
			content:
				"Today's modern suspensions require precise wheel alignments that can only be achieved through a modern alignment system.",
		},
	],
	otherServices: [
		'Tyres & Balancing',
		'Air Conditioning',
		'Auto Electrics',
		'Suspension',
		'Key Drop-off box',
		'Battery replacement',
		'General Mechanical Repairs',
		'LogBrake & Clutch Services',
		'Engine Diagnostic',
		'LPG',
	],
	reasons: [
		{
			id: 1,
			image: '/images/TZAutomotiveRepairs/experience.png',
			title: 'Years of experience',
			desc:
				'Driven by a passion for perfection, our master mechanics combine years of expertise with the latest diagnostic tools to deliver premium service you can feel in every mile.',
		},
		{
			id: 2,
			image: '/images/TZAutomotiveRepairs/trust.png',
			title: 'Service you can trust',
			desc:
				'We don’t just meet expectations; we redefine them. From our hand-picked products to our white-glove service, everything we do is designed with your absolute satisfaction in mind.',
		},
		{
			id: 3,
			image: '/images/TZAutomotiveRepairs/above.png',
			title: 'Above and beyond',
			desc:
				"Your satisfaction isn’t just a goal—it’s our guarantee. If your experience is anything less than perfect, tell us, and we will move mountains to make it right.",
		},
	],
	about: {
		image: '/images/TZAutomotiveRepairs/owner.jpg',
		content: [
			<div key="sub-title">About TZ Automotive Repairs</div>,
			<div key="title">How we started our journey</div>,
			<div key="content">
                At <strong>TZ Automotive Repairs</strong>, we believe that every vehicle is a masterpiece of engineering that deserves nothing less than perfection. Our mission goes beyond simple maintenance; we provide a sanctuary for automotive excellence and reliability.
                <br />
                <br />
                We are proud to offer a truly comprehensive suite of services, from precision diagnostics to intricate mechanical overhauls, covering all makes and models. Our team of master technicians brings decades of collective experience and a passion for craftsmanship to every vehicle we service.
                <br />
                <br />
                We don’t just fix cars—we restore your confidence on the road. When we say we get it right the first time, it’s more than a slogan; it’s our unwavering commitment to your safety and satisfaction.
				<br />
				<br />
				<span style={{ fontSize: '1.4rem', fontWeight: '500' }}>
					Thant Zin
				</span>
				<br />
				<span style={{ fontSize: '0.9rem' }}>
					Owner - TZ Automotive Repairs.
				</span>
			</div>,
		],
	},
	reviews: [
		{
			link: 'https://www.google.com/search?q=tz+automotive+repairs&oq=TZ&gs_lcrp=EgZjaHJvbWUqCAgAEEUYJxg7MggIABBFGCcYOzIGCAEQRRg7MgYIAhBFGDkyBggDEEUYQDIGCAQQRRg8MgYIBRBFGDwyBggGEEUYPDIGCAcQRRg80gEIMjUzN2owajeoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0x6ad613de7e8d171b:0x5bb5b9af5e17ef15,1,,,,',
			score: '5.0',
			totalReview: '1',
			type: 'Google',
		},
	],
	contacts: {
		googleMap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3144.240141587989!2d145.184609!3d-37.994858799999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad613de7e8d171b%3A0x5bb5b9af5e17ef15!2sTZ%20Automotive%20Repairs!5e0!3m2!1sen!2sid!4v1765868327810!5m2!1sen!2sid',
		address: ['222 Cheltenham Road', 'Keysborough, VIC 3173.'],
		phone: '04 2696 5909',
		email: 'info@tzautomotiverepairs.com.au',
		opening: ['Monday - Friday: 9am - 5pm', 'Saturday: 9am - 1pm'],
	},
	isExtraLogos: true,
	extraLogos: [
		'/images/Others/michelin-logo.png',
		'/images/Others/BFGoodrich-logo-small-med.png',
		'/images/Others/continental-logo.png',
		'/images/Others/pirelli-logo.png',
		'/images/Others/bridgestone-logo.png',
		'/images/Others/zeta-logo.png',
	],
	isExtraLogosFeatured: true,
};

export default data;
